import { NUMBER_BOOLEAN_CHOICES } from 'constants/numberBooleanChoices';
import { Resources } from 'constants/resources';

import { Controller, useFormContext } from 'react-hook-form';
import { DateTimeRangePicker } from 'shared/mui/DatePicker/DateTimeRangePicker/DateTimeRangePicker';
import { FilterFieldConfig } from 'shared/mui/Filter/config';
import {
  AutocompleteInput,
  AutocompleteMultiselectInput,
  TextInput,
} from 'shared/react-admin/Inputs';
import { ReferenceArrayInput } from 'shared/react-admin/ReferenceInputs';

export const useUsersListFilterFields = (): FilterFieldConfig[] => {
  const { control } = useFormContext();

  return [
    {
      name: 'appliedDate',
      label: 'Последняя активность',
      chipType: 'dateTimeRange',
      input: (
        <Controller
          control={control}
          name="appliedDate"
          render={({ field: { onChange, onBlur, value } }) => (
            <DateTimeRangePicker
              label="Последняя активность / период"
              maxDate={new Date()}
              onBlur={onBlur}
              onChange={onChange}
              value={value}
            />
          )}
        />
      ),
    },
    {
      name: 'lastName',
      label: 'Фамилия',
      chipType: 'text',
      input: (
        <TextInput
          fullWidth
          helperText={false}
          key="lastName"
          label="Фамилия"
          name="lastName"
          source="lastName"
          variant="outlined"
        />
      ),
    },
    {
      name: 'firstName',
      label: 'Имя',
      chipType: 'text',
      input: (
        <TextInput
          fullWidth
          helperText={false}
          key="firstName"
          label="Имя"
          name="firstName"
          source="firstName"
          variant="outlined"
        />
      ),
    },
    {
      name: 'roleEntities',
      label: 'Роли',
      chipType: 'multiselect',
      chipProps: {
        resource: 'roles',
        limitTags: 1,
      },
      input: (
        <ReferenceArrayInput perPage={100} reference="roles" source="roleEntities">
          <AutocompleteMultiselectInput
            helperText={false}
            label="Роли"
            name="roleEntities"
            optionText="name"
            size="small"
          />
        </ReferenceArrayInput>
      ),
    },
    {
      name: 'enabled',
      label: 'Активность',
      chipType: 'text',
      chipProps: {
        getName: (filterValue: string) =>
          NUMBER_BOOLEAN_CHOICES.find((v) => filterValue === v.id)?.label || '',
      },
      input: (
        <AutocompleteInput
          choices={NUMBER_BOOLEAN_CHOICES}
          fullWidth
          helperText={false}
          key="enabled"
          label="Активность"
          name="enabled"
          optionText="label"
          source="enabled"
          variant="outlined"
        />
      ),
    },
    {
      name: 'reddyNumber',
      label: 'Reddy',
      chipType: 'text',
      input: (
        <TextInput
          fullWidth
          helperText={false}
          key="reddyNumber"
          label="Reddy"
          name="reddyNumber"
          source="reddyNumber"
          variant="outlined"
        />
      ),
    },
    {
      name: 'email',
      label: 'E-mail',
      chipType: 'text',
      input: (
        <TextInput
          fullWidth
          helperText={false}
          key="email"
          label="E-mail"
          name="email"
          source="email"
          variant="outlined"
        />
      ),
    },
    {
      name: 'merchants',
      label: 'Доступ к мерчантам',
      chipType: 'multiselect',
      chipProps: {
        resource: Resources.Merchants,
        limitTags: 1,
      },
      input: (
        <ReferenceArrayInput perPage={100} reference={Resources.Merchants} source="merchants">
          <AutocompleteMultiselectInput
            filterToQuery={(searchText: string) => ({ name: searchText })}
            helperText={false}
            label="Доступ к мерчантам"
            name="merchants"
            optionText="name"
            size="small"
          />
        </ReferenceArrayInput>
      ),
    },
  ];
};
